/**
 * Whether this page can support offline use at all.
 *
 * The Cache API and service workers are gated on a secure context — HTTPS, or
 * localhost. Served over plain HTTP on any other host, both are simply absent
 * and every offline feature silently does nothing: downloads have nowhere to
 * go, and a reload has no shell to load from.
 *
 * That failure is invisible without checking for it, which makes it worth a
 * banner rather than a mystery (FR-029: degrade gracefully, not silently).
 */

export const offlineCapability = () => {
  if (typeof window === 'undefined') return { capable: false, reason: 'unsupported' };

  // localhost is a secure context by definition; anything else needs HTTPS.
  if (window.isSecureContext === false) return { capable: false, reason: 'insecure-context' };
  if (typeof caches === 'undefined') return { capable: false, reason: 'no-cache-api' };
  if (!('serviceWorker' in navigator)) return { capable: false, reason: 'no-service-worker' };

  return { capable: true, reason: null };
};

export const CAPABILITY_MESSAGES = {
  'insecure-context':
    'Offline mode is unavailable on this address. It needs a secure page — https, or localhost.',
  'no-cache-api':
    'Offline mode is unavailable: this browser is not offering storage on this page.',
  'no-service-worker':
    'Offline mode is unavailable: this browser does not support service workers.',
  unsupported: 'Offline mode is unavailable in this environment.',
};
